import { map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Chart from './Chart';

const SizeChart = ({ sizeChart }) => {
  return (
    <div id="size-chart">
      {map(sizeChart.sizeChartTables, (table, i) => (
        <Chart key={`chart-${i}`} data={table.data} heading={table.heading} />
      ))}
    </div>
  );
};

SizeChart.propTypes = {
  sizeChart: PropTypes.shape({
    sizeChartTables: PropTypes.arrayOf(
      PropTypes.shape({
        heading: PropTypes.string,
        data: PropTypes.arrayOf(
          PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string.isRequired }))
        ),
      })
    ),
  }),
};

export default SizeChart;
